import { CbmImpl } from "~/modules/cbm";
import { Action } from "~/modules/actions/Action";
import {
    checkReservationExists,
    checkWorker,
    getReservationsByTask,
    handleGetParticipantsByTask
} from "~/modules/actions/ActionUtils";
import { EVENTS } from "~/modules/telemetry/Analytics";
import { AnalyticsImpl } from "~/modules/telemetry/AnalyticsImpl";
import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";
import { getLogger, LoggerName } from "~/modules/logger";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";
import { TaskParticipant } from "~/modules/participant";




export type GetTaskParticipantsResponse = Array<TaskParticipant>;





























export class GetTaskParticipants implements Action<Promise<GetTaskParticipantsResponse>> {
    


    readonly #taskSid: string;

    constructor(taskSid: string) {
        this.#taskSid = taskSid;
    }

    async run(ctx: {}): Promise<GetTaskParticipantsResponse> {
        const context = ctx as ContextManager;
        const logger = getLogger(context)(LoggerName.Actions);

        const taskRouter = context.retrieveInstanceOf(ContextInstance.TaskRouter, TaskRouterImpl);
        await taskRouter.init();
        const worker = taskRouter.worker;

        const cbm = context.retrieveInstanceOf(ContextInstance.CbmImpl, CbmImpl);
        await cbm.init();

        const analytics = context.retrieveInstanceOf(ContextInstance.AnalyticsImpl, AnalyticsImpl);

        logger.debug(`GetTaskParticipants invoked with taskSid: ${this.#taskSid}`);

        checkWorker(worker, {
            actionName: "GetTaskParticipants",
            moduleName: "actions/Task",
            analytics,
            context,
            worker,
            logger,
            event: EVENTS.GetTaskParticipantsCompleted,
            extra: {
                taskSid: this.#taskSid
            }
        });

        
        
        const reservations = getReservationsByTask(worker, this.#taskSid);
        const reservation = reservations[0];

        checkReservationExists(reservation, this.#taskSid, {
            actionName: "GetTaskParticipants",
            moduleName: "actions/Task",
            analytics,
            context,
            worker,
            logger,
            event: EVENTS.GetTaskParticipantsCompleted,
            extra: {
                taskSid: this.#taskSid
            }
        });

        return handleGetParticipantsByTask(cbm, reservation.task, {
            actionName: "GetTaskParticipants",
            moduleName: "actions/Task",
            analytics,
            context,
            worker,
            logger,
            event: EVENTS.GetTaskParticipantsCompleted,
            extra: {
                taskSid: this.#taskSid
            }
        });
    }
}
